interface SingleFlightRule {
  method: "ANY" | "DELETE" | "GET" | "HEAD" | "PATCH" | "POST" | "PUT";
  requestURL: RegExp;
}

const SINGLE_FLIGHT_RULES: SingleFlightRule[] = [
  { method: "GET", requestURL: /.*/ },
  { method: "HEAD", requestURL: /.*/ },
  {
    method: "POST",
    requestURL: /api\/session\/refresh$/,
  },
];

export const shouldUseSingleFlight = (url: string, method: string): boolean =>
  SINGLE_FLIGHT_RULES.some(({ method: m, requestURL }) => {
    if (m !== "ANY" && m !== method) {
      return false;
    }

    return requestURL.test(url);
  });

const inflight = new Map<string, Promise<unknown>>();

export function singleFlight<T>(
  key: string,
  factory: () => Promise<T>
): Promise<T> {
  const existing = inflight.get(key);
  if (existing) {
    return existing.then((r) => r as T);
  }

  const p = factory().finally(() => inflight.delete(key));
  inflight.set(key, p);

  return p;
}
